import { Box, Button, Grid, Loader, Table } from 'flexibull2'
import { DropDown } from 'flexibull2/build/dropdown'
import React, { useContext, useEffect, useState } from 'react'
import InstitutionContext from '../../../context/institution/institutionContext'
import { ColorBox } from '../../components/Styles/ColorBox.style'
import { Theme } from '../../config/theme'
import AddPaylog from './AddPaylog'

const ManagePaylog = ({ orgShortName, open, setOpen }) => {
    const institutionContext = useContext(InstitutionContext)
    const [isEdit, setIsEdit] = useState(false)
    const [editData, setEditData] = useState(null)

    const { loading, getPaylogConfig, paylogConfig } = institutionContext

    const onEdit = (data) => {
        setIsEdit(true)
        setEditData(data)
        setOpen(true)
    }

    const handleSuccessCallback = () => {
        getPaylogConfig(orgShortName)
        setIsEdit(false)
        setEditData(null)
        setOpen(false)
    }

    useEffect(() => {
        getPaylogConfig(orgShortName)
        // eslint-disable-next-line
    }, [])

    if (loading) {
        return (
            <Box vAlign height={`calc(100vh - 200px)`}>
                <Box margin="0 auto" align="center">
                    <Loader color={Theme.PrimaryColor} />
                </Box>
            </Box>
        )
    }

    return (
        <>
            <div>
                <Grid default="1fr">
                    <Box pad="20px 0" align="right">
                        <Button
                            width={140}
                            pad="0 1px"
                            onClick={() => setOpen(true)}
                            spaceLeft
                        >
                            Add Paylog
                        </Button>
                    </Box>
                </Grid>
                <Box margin="5px 0 5px 0" align="left">
                    <Table style={{ paddingTop: '10px' }}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Paylog ID</th>
                                    <th>School Short Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{paylogConfig?.paylog_id}</td>
                                    <td>{paylogConfig?.schoolShortName}</td>
                                    <td>
                                        <ColorBox>
                                            <DropDown
                                                label={
                                                    <Button
                                                        pale
                                                        height={20}
                                                        style={{
                                                            border: 'none',
                                                        }}
                                                    >
                                                        <i className="icon-dot-3" />
                                                    </Button>
                                                }
                                                trigger="hover"
                                                menuAlign="top right"
                                                menuList={[
                                                    {
                                                        onClick: () =>
                                                            onEdit(
                                                                paylogConfig
                                                            ),
                                                        label: 'Edit Config',
                                                        iconLeft:
                                                            'icon-edit tblue',
                                                    },
                                                ]}
                                                style={{
                                                    cursor: 'pointer',
                                                }}
                                            />
                                        </ColorBox>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Table>
                </Box>

                <AddPaylog
                    open={open}
                    isEdit={isEdit}
                    editData={editData}
                    orgShortName={orgShortName}
                    loading={loading}
                    setOpen={setOpen}
                    callback={handleSuccessCallback}
                />
            </div>
        </>
    )
}

export default ManagePaylog
